import './FloatingLessonBubble.css';

export const FloatingLessonBubble = () => {
  return (
    <div className="lesson-bubble-wrapper">
      <div className="start-label">START</div>
    </div>
  );
};
